

function Signup() {
    return(
        
        <p>signup component for people </p>

    );
}

export default Signup;